import styled from 'styled-components'
import React, { PureComponent, ReactElement } from 'react'
import { input } from '../../styles'
import InputProps from './InputProps'

export const Input = styled.input`
    outline: none;
    -webkit-appearance: none;
    border: none;
    width: 100%;
    padding: 0;
    ${({ placeholderTextColor }): string => {
        if (placeholderTextColor) {
            return `
                ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
                    color: ${placeholderTextColor};
                    opacity: 1; /* Firefox */
                }
                
                ::-ms-input-placeholder { /* Microsoft Edge */
                    color: ${placeholderTextColor};
                }`
        }
        return ''
    }}
    ${input}
`

class InputClass extends PureComponent<InputProps> {
    public static displayName = 'InputElement'
    private inputRef = React.createRef<HTMLInputElement>()

    constructor(props: InputProps) {
        super(props)
        this.onChangeHandler = this.onChangeHandler.bind(this)
    }

    protected onChangeHandler(e: React.ChangeEvent<HTMLInputElement>): void {
        const { onChange } = this.props

        onChange && onChange({ value: e.target.value })
    }

    public blur(): void {
        const input = this.inputRef.current
        /* istanbul ignore else */
        if (input !== null) {
            input.blur()
        }
    }

    public focus(): void {
        const input = this.inputRef.current
        /* istanbul ignore else */
        if (input !== null) {
            input.focus()
        }
    }

    public render(): ReactElement {
        const { testID, ...rest } = this.props
        return (
            <Input
                data-testid={testID}
                {...rest}
                ref={this.inputRef}
                onChange={this.onChangeHandler}
            />
        )
    }
}

export default InputClass
